// Ritmo e velocidade de leitura — UMA conta para a página do livro e para a Home.
//
// Pente fino 03/10/2026 (QA-07). Depois de uma leitura de 11 páginas, a mesma
// tela dizia "RITMO · 7 DIAS 11" e logo abaixo "RITMO 2 pág/dia" (11 ÷ 7, como
// se a pessoa tivesse lido nos 7 dias), previa o fim em 205 dias e mostrava
// "VELOCIDADE 11.0 pág/min" — porque quem registra depois de ler longe do app
// manda 11 páginas com 1 minuto de sessão. Os números se contradiziam.

type Sessao = { date?: string | null; pages?: number | null; minutes?: number | null };

/** Acima disso a sessão não mediu leitura: foi registro do que se leu antes. */
export const PAGINAS_POR_MINUTO_MAX = 3;
/** Sessão curta demais não mede velocidade nenhuma. */
export const MINUTOS_MIN = 3;

const chaveSP = (ms: number) => new Date(ms - 3 * 3600000).toISOString().slice(0, 10);

/** Ritmo dos últimos 7 dias, dividido pelos dias que de fato contam: do
 *  primeiro dia com leitura na janela até hoje (no máximo 7). Livro começado
 *  hoje com 11 páginas = 11/dia, não 2. */
export function ritmoRecente(sessoes: Sessao[] | null | undefined, agora = Date.now()) {
  const hoje = chaveSP(agora);
  const corte = chaveSP(agora - 6 * 86400000);
  const naJanela = (sessoes || []).filter((s) => (s.date || '') >= corte && (s.date || '') <= hoje);
  const total = naJanela.reduce((t, s) => t + (Number(s.pages) || 0), 0);
  if (!total) return { total: 0, dias: 7, porDia: 0 };
  const primeiro = naJanela.map((s) => String(s.date)).sort()[0];
  const dias = Math.max(1, Math.min(7, Math.round((Date.parse(hoje) - Date.parse(primeiro)) / 86400000) + 1));
  return { total, dias, porDia: total / dias };
}

/** Páginas por minuto só das sessões que mediram leitura de verdade (Modo foco
 *  com tempo plausível). Sem nenhuma, null — e a tela não inventa tempo. */
export function velocidadePlausivel(sessoes: Sessao[] | null | undefined): number | null {
  const boas = (sessoes || []).filter((s) => {
    const m = Number(s.minutes) || 0;
    const p = Number(s.pages) || 0;
    return m >= MINUTOS_MIN && p > 0 && p / m <= PAGINAS_POR_MINUTO_MAX;
  });
  const min = boas.reduce((t, s) => t + (Number(s.minutes) || 0), 0);
  if (!min) return null;
  return boas.reduce((t, s) => t + (Number(s.pages) || 0), 0) / min;
}

/** 1,5 — com vírgula, como se escreve em português. */
export const decimal = (n: number, casas = 1) => n.toFixed(casas).replace('.', ',');
